import { MapLike } from '../core'
import { IPayloadAttributes, IPayloadInstance } from './interfaces'

/**
 * @enum UplinkPayloadAttributeMetaTypes
 * classifies attributes in payload instance by the intended use / meaning type. Used where system needs to route parts of uplink differently
 */
export enum UplinkPayloadAttributeMetaTypes {
  DEVICE_CONFIG = 'DEVICE_CONFIG', // confirmation from device about its configuratble settings
  DEVICE_DIAGNOSTIC = 'DEVICE_DIAGNOSTIC', // value relating to some diagnostic measure in diagnostic mode
  DEVICE_ERROR = 'DEVICE_ERROR', // error report relating to the device eg:  batteryErr | linkCheckErr
  DEVICE_MEASUREMENT = 'DEVICE_MEASUREMENT', // value relating to some monitored aspect of the Thing device is attached to
  DEVICE_META_DATA = 'DEVICE_META_DATA', // data about the device itself eg: deviceEUI | firmwareVersion | messageType | batteryVoltage
  DEVICE_STATUS = 'DEVICE_STATUS', // report about the device stagus eg;   reboot | charging | gpsFix
}

export type PayloadAttributeMetaData = {
  metaType: UplinkPayloadAttributeMetaTypes
  transformIn?: (incoming: MapLike<any>, existing: MapLike<any>) => MapLike<any>
}

export type UplinkPayloadMetaData<T extends IPayloadInstance<IPayloadAttributes>> = Required<{
  [k in keyof T]: PayloadAttributeMetaData
}>
